//
//
//
//
//
//
//
//

import ns from 'nanoscroller/bin/javascripts/jquery.nanoscroller';
import Vue from "vue";
import "./lib/css/emoji.css";
import "nanoscroller/bin/css/nanoscroller.css";

import storageUtils from "./lib/js/util";
import { EmojiPicker } from "./lib/js/emoji-picker";
import { getGuid } from './lib/js/jquery.emojiarea';

import './lib/img/IconsetSmiles.png';
import './lib/img/IconsetSmiles_1x.png';
import './lib/img/IconsetW.png';
import './lib/img/IconsetW_1x.png';

export default {
  name: "VueEmoji",
  data: function data() {
    return {
      id: getGuid()
    };
  },

  props: {
    width: {
      type: String,
      default: '200'
    },
    height: {
      type: String,
      default: '50'
    },
    value: {
      type: String,
      default: ''
    }
  },
  watch: {
    value: function value(newVal) {
      var _this = this;

      Vue.nextTick(function () {
        _this.$el.querySelector(".emoji-wysiwyg-editor").innerHTML = newVal;
      });
    }
  },
  methods: {
    initEmojiPlugin: function initEmojiPlugin() {
      var _this2 = this;

      window.emojiPicker = new EmojiPicker({
        emojiable_selector: "#" + this.id + " [data-vue-emojiable=true]",
        assetsPath: "",
        popupButtonClasses: "smile-icon",
        onChangecontent: function onChangecontent(textAreaValue) {
          _this2.$emit('input', { data: textAreaValue });
        }
      });
      window.emojiPicker.discover();
      Vue.nextTick(function () {
        var editor = _this2.$el.querySelector(".emoji-wysiwyg-editor");
        editor.style.width = _this2.width + "px";
        editor.style.height = _this2.height + "px";
        _this2.$el.querySelector(".emoji-picker-container").style.width = Number(_this2.width) + 50 + "px";
      });
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    Vue.nextTick(function () {
      storageUtils();
      _this3.initEmojiPlugin();
    });
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/d02/applications/www/frontend/cashback.wmr.ru/releases/232/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/emoji-vue/src/VueEmoji.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/d02/applications/www/frontend/cashback.wmr.ru/releases/232/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/emoji-vue/src/VueEmoji.vue
// module chunks = 152